import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { FiX } from "react-icons/fi";
import AuthStore from "../stores/AuthStore";
import UserStore from "../stores/UserStore";
import { identifyUser, resetUser, captureEvent } from "src/services/PostHogService";
import { Spinner } from "../components/-common";
import Sidebar from "../components/Sidebar";
import AuthRoutes from "../components/@Auth";
import People from "../components/@People";
import Enrollment from "../components/@Enrollment";
import Curriculum from "../components/@Curriculum";
import Products from "../components/@Products";
import Mobile from "../components/@Mobile";
import Shipping from "../components/@Shipping";
import Analytics from "../components/@Analytics";
import PromoCodes from "src/components/@PromoCodes";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";

const ToastClose = ({ closeToast }) => (
  <div className="toast-close">
    <FiX size={20} onClick={closeToast} />
  </div>
);

function Main() {
  const location = useLocation();

  useEffect(() => {
    captureEvent('$pageview');
  }, [location]);

  return (
    <div className="main-content">
      <Sidebar />
      <Routes>
        <Route path="/people/*" element={<People />} />
        <Route path="/enrollment/*" element={<Enrollment />} />
        <Route path="/curriculum/*" element={<Curriculum />} />
        <Route path="/products/*" element={<Products />} />
        <Route path="/promo/*" element={<PromoCodes />} />
        <Route path="/mobile" element={<Mobile />} />
        <Route path="/shipping/*" element={<Shipping />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="*" element={<Navigate to="/people" replace />} />
      </Routes>
    </div>
  );
}

const App = observer(() => {
  useEffect(() => {
    AuthStore.initializeAuth();
  }, []);

  useEffect(() => {
    if (AuthStore.authenticated && UserStore?.user?.id) {
      identifyUser(UserStore.user.id);
    } else if (!AuthStore.authenticated) {
      resetUser();
    }
  }, [AuthStore.authenticated, UserStore?.user?.id]);
  
  if (!AuthStore.authDetermined || (AuthStore.authenticated && !UserStore?.user?.id && UserStore.loading)) {
    return (
      <div className="root loading">
        <Spinner alt={true} />
      </div>
    );
  }

  if (AuthStore.authenticated) return <Main />;
  return <AuthRoutes />;
});

function ProvidersWrappedApp() {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        closeButton={<ToastClose />}
        toastClassName="lpm-toast"
      />
        <App />
    </BrowserRouter>
  );
}

export default ProvidersWrappedApp;
